import React, { useEffect, useRef, useContext } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import API_PATH from "../../constants/config.json";
import Cookies from "js-cookie";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import DataIconsTooltip from "../StationDetails/Tooltip/DataIconsTooltip";
const useStyles = makeStyles((theme) => ({}));
const axios = require("axios");
const queryString = require("query-string");
const API_URL = process.env.REACT_APP_BASE_URL;
const AWS = require("aws-sdk");

const ExportStations = (props) => {
  //details options
  const [loader, setLoader] = React.useState(false);
  const [anchorElDetailsMenu, setanchorElDetailsMenu] = React.useState(null);
  const [idintityPool, setIdintityPool] = React.useState("");
  const [aswLogins, setAswLogins] = React.useState("");
  const openDetailsMenu = Boolean(anchorElDetailsMenu);
  useEffect(() => {
    getAswToken();
  }, []);
  const handleClickDetailsMenu = (event) => {
    props.setShowExternalLayers(false);
    props.setShowDataPointLayers(false);
    setanchorElDetailsMenu(event.currentTarget);
  };
  const handleCloseDetailsMenu = () => {
    setanchorElDetailsMenu(null);
  };
  const getAswToken = () => {
    try {
      axios({
        method: "get",
        url: API_URL + API_PATH.getAWSs3TokenAPI,
        headers: {
          agencyid: sessionStorage.getItem("agency_id"),
          payload: Cookies.get("payload"),
        },
      }).then(async function (response) {
        if (response.status && response.status == "200") {
          let aswData = response.data;
          setIdintityPool(aswData.data.IdentityPoolId);
          setAswLogins(aswData.data.Logins);
        } else {
          console.log("");
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const downloadStationsFiles = (file) => {
    handleCloseDetailsMenu();
    setLoader(true);
    let data = {
      checkedCsv: false,
      checkedGeoJson: false,
      signalPlanningCsv: false,
      checkedShape: false,
      checkedIntersection: true,
      checkedMidblock: true,
      endDate: "",
      startDate: "",
    };
    data[file] = true;
    data["domainname"] = window.location.origin;
    try {
      axios({
        method: "POST",
        data: data,
        headers: {
          payload: Cookies.get("payload"),
          agencyid: sessionStorage.getItem("agency_id"),
        },
        url: API_URL + API_PATH.exportStations,
      })
        .then(async function (response) {
          let OIDToken = Cookies.get("idToken");
          axios({
            method: "post",
            url: API_URL + API_PATH.getAwsCredentials,
          }).then(async function (awsResponse) {
            if (awsResponse.status && awsResponse.status == "200") {
              if (awsResponse.data.aws) {
                AWS.config.update({
                  region: "us-west-2",
                  credentials: new AWS.Credentials({
                    accessKeyId: awsResponse.data.aws.accessKeyId,
                    secretAccessKey: awsResponse.data.aws.secretAccessKey,
                  }),
                });
                let s3 = new AWS.S3();
                s3.getObject(
                  {
                    Bucket: response.data.data.bucket_name,
                    Key: "downloads/" + response.data.data.file_name,
                  },
                  function (error, data) {
                    if (error != null) {
                      console.log("error", error);
                      setLoader(false);
                    } else {
                      let blob = new Blob([data.Body], {
                        type: data.ContentType,
                      });
                      let link = document.createElement("a");
                      link.href = window.URL.createObjectURL(blob);
                      link.download = response.data.data.file_name;
                      link.click();
                      setLoader(false);
                    }
                  }
                );
              }
            }
          });
        })
        .catch(function (error) {
          console.error(error);
          setLoader(false);
        });
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  };
  //end details options

  const handleClickAway = () => {
    setanchorElDetailsMenu(null);
  };
  return (
    <React.Fragment>
      <DataIconsTooltip title="Export summary data">
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls="long-menu"
          aria-expanded={openDetailsMenu ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleClickDetailsMenu}
          className="btn-stations-download"
          disabled={loader}
          style={props.polygonActive ? { right: "509px" } : null}
        >
          {!loader ? (
            <img src={require("../../assets/icons/map/export-stations.png")} />
          ) : (
            <div className={"loader"}></div>
          )}
        </IconButton>
      </DataIconsTooltip>
      {openDetailsMenu && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <div
            className="station-actions"
            style={{ top: "115px", right: "517px" }}
            data-testid="actionsContainer"
          >
            <ul>
              <li onClick={() => downloadStationsFiles("checkedCsv")}>
                <img src={require("../../assets/icons/station_download.svg")} />{" "}
                All stations CSV
              </li>
              <li onClick={() => downloadStationsFiles("checkedShape")}>
                <img src={require("../../assets/icons/station_download.svg")} />{" "}
                All stations Shapefile
              </li>
              <li onClick={() => downloadStationsFiles("checkedGeoJson")}>
                <img src={require("../../assets/icons/station_download.svg")} />{" "}
                All stations GeoJSON
              </li>
              <li className="divider"></li>
              <li onClick={() => downloadStationsFiles("signalPlanningCsv")}>
                <img src={require("../../assets/icons/station_download.svg")} />{" "}
                Capacity planning CSV
              </li>
            </ul>
          </div>
        </ClickAwayListener>
      )}
    </React.Fragment>
  );
};

export default ExportStations;
